module.exports = __webpack_public_path__ + "static/media/fury-strike.79756625.png";